import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import "../styles/Gallery.css";

// ======================================================
// GALLERY IMAGES
// ======================================================

import gallery1 from "../assets/galleryimg1.avif";
import gallery2 from "../assets/galleryimg2.avif";
import gallery3 from "../assets/galleryimg3.avif";
import gallery4 from "../assets/galleryimg4.avif";
import gallery5 from "../assets/galleryimg1.avif";
import gallery6 from "../assets/galleryimg2.avif";
// ======================================================
// GALLERY DATA
// ======================================================

const galleryItems = [
  {
    id: 1,
    image: gallery1,
    category: "Hospital Standards",
    tag: "Accreditation",
    title: "JCI Quality Inspection in Operating Theater",
  },

  {
    id: 2,
    image: gallery2,
    category: "Team Synergy",
    tag: "Joint Training",
    title: "Healthcare Team Collaborative Strategy Meeting",
  },

  {
    id: 3,
    image: gallery3,
    category: "Nursing Excellence",
    tag: "CME / CNE",
    title: "Clinical Care Skill Assessment for Nursing Staff",
  },

  {
    id: 4,
    image: gallery4,
    category: "Specialized Training",
    tag: "Education",
    title: "Pediatric Care Standards Workshop",
  },

  {
    id: 5,
    image: gallery5,
    category: "Simulation Lab",
    tag: "Paramedical",
    title: "Paramedic Simulation Lab Session",
  },

  {
    id: 6,
    image: gallery6,
    category: "Emergency Response",
    tag: "Safety Standards",
    title: "Emergency Medical Response Team Drill",
  },
];


// ======================================================
// COMPONENT
// ======================================================

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);


  // ====================================================
  // DISABLE BODY SCROLL WHEN MODAL IS OPEN
  // ====================================================

  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);


  // ====================================================
  // ESC KEY
  // ====================================================

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setSelectedImage(null);
      }
    };

    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, []);


  // ====================================================
  // OPEN MODAL
  // ====================================================

  const openModal = (item) => {
    setSelectedImage(item);
  };


  // ====================================================
  // CLOSE MODAL
  // ====================================================

  const closeModal = () => {
    setSelectedImage(null);
  };


  return (
    <>
      {/* ==================================================
          GALLERY SECTION
      ================================================== */}

      <section className="gallery-section">

        <div className="gallery-container">

          {/* ==================================================
              HEADER
          ================================================== */}

          <div className="gallery-header">

            <span className="gallery-eyebrow">
              VISUAL EVIDENCE
            </span>

            <h2>
              Impact in Action Gallery
            </h2>

            <p>
              Explore photos of our active accreditation audits,
              CME workshops, simulation drills, and healthcare
              skill development sessions.
            </p>

          </div>


          {/* ==================================================
              GALLERY GRID
          ================================================== */}

          <div className="gallery-grid">

            {galleryItems.map((item) => (

              <article
                key={item.id}
                className="gallery-card"
                role="button"
                tabIndex={0}
                onClick={() => openModal(item)}
                onKeyDown={(event) => {
                  if (
                    event.key === "Enter" ||
                    event.key === " "
                  ) {
                    event.preventDefault();
                    openModal(item);
                  }
                }}
              >

                {/* IMAGE */}

                <img
                  src={item.image}
                  alt={item.title}
                  className="gallery-image"
                  loading="lazy"
                />


                {/* OVERLAY */}

                <div className="gallery-overlay"></div>


                {/* CARD CONTENT */}

                <div className="gallery-card-content">

                  <span className="gallery-category">
                    {item.category}
                  </span>


                  <div className="gallery-card-bottom">

                    <span className="gallery-tag">
                      {item.tag}
                    </span>

                    <h3>
                      {item.title}
                    </h3>

                  </div>

                </div>

              </article>

            ))}

          </div>

        </div>

      </section>


      {/* ==================================================
          IMAGE MODAL
      ================================================== */}

      {selectedImage && (

        <div
          className="gallery-modal"
          onClick={closeModal}
        >

          <div
            className="gallery-modal-box"
            onClick={(event) => event.stopPropagation()}
          >

            {/* ==================================================
                MODAL HEADER
            ================================================== */}

            <div className="gallery-modal-header">

              <div className="gallery-modal-heading">

                <span className="gallery-modal-category">
                  {selectedImage.category}
                </span>

                <h3>
                  {selectedImage.title}
                </h3>

              </div>


              {/* CLOSE */}

              <button
                type="button"
                className="gallery-close"
                onClick={closeModal}
                aria-label="Close image"
              >
                <X size={23} strokeWidth={2} />
              </button>

            </div>


            {/* ==================================================
                MODAL IMAGE
            ================================================== */}

            <div className="gallery-modal-body">

              <img
                src={selectedImage.image}
                alt={selectedImage.title}
              />

            </div>

          </div>

        </div>

      )}

    </>
  );
};

export default Gallery;